import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "layout-content"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_a_input = _resolveComponent("a-input");
  const _component_a_form_item = _resolveComponent("a-form-item");
  const _component_a_col = _resolveComponent("a-col");
  const _component_a_input_number = _resolveComponent("a-input-number");
  const _component_a_textarea = _resolveComponent("a-textarea");
  const _component_a_row = _resolveComponent("a-row");
  const _component_a_tab_pane = _resolveComponent("a-tab-pane");
  const _component_a_tabs = _resolveComponent("a-tabs");
  const _component_a_form = _resolveComponent("a-form");
  const _component_a_spin = _resolveComponent("a-spin");
  const _component_a_modal = _resolveComponent("a-modal");
  return _openBlock(), _createBlock(_component_a_modal, {
    visible: $setup.IsShow,
    "onUpdate:visible": _cache[3] || (_cache[3] = $event => $setup.IsShow = $event),
    confirmLoading: $setup.DMConfig.loading,
    title: $setup.DMConfig.Title,
    bodyStyle: {
      padding: '5px'
    },
    width: $setup.DMConfig.Width,
    "wrap-class-name": $setup.DMConfig.ModelClass,
    onOk: $setup.SubmitForm
  }, {
    default: _withCtx(() => [_createVNode(_component_a_spin, {
      spinning: $setup.DMConfig.loading,
      delay: 1000
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_a_form, {
        ref: "RefForm",
        model: $setup.DMConfig.Model,
        "label-col": $setup.DMConfig.DMForm.form.labelCol
      }, {
        default: _withCtx(() => [_createVNode(_component_a_tabs, null, {
          default: _withCtx(() => [_createVNode(_component_a_tab_pane, {
            forceRender: "true",
            key: "1",
            tab: "基本信息"
          }, {
            default: _withCtx(() => [_createVNode(_component_a_row, {
              gutter: 24,
              style: {
                "padding-top": "30px"
              }
            }, {
              default: _withCtx(() => [_createVNode(_component_a_col, {
                md: 24,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fTitle",
                  label: "分类标题",
                  rules: [{
                    required: true,
                    message: '请输入客户代码!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input, {
                    type: "text",
                    placeholder: "",
                    value: $setup.DMConfig.Model.fTitle,
                    "onUpdate:value": _cache[0] || (_cache[0] = $event => $setup.DMConfig.Model.fTitle = $event),
                    allowClear: "true"
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 24,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fBeforeDay",
                  label: "到期前开始提醒",
                  rules: [{
                    required: true,
                    message: '请输入到期前天数!'
                  }]
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_input_number, {
                    value: $setup.DMConfig.Model.fBeforeDay,
                    "onUpdate:value": _cache[1] || (_cache[1] = $event => $setup.DMConfig.Model.fBeforeDay = $event),
                    min: 0,
                    max: 90
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_a_col, {
                md: 24,
                sm: 24
              }, {
                default: _withCtx(() => [_createVNode(_component_a_form_item, {
                  name: "fBeforeTipTpl",
                  label: "到期提醒模板"
                }, {
                  default: _withCtx(() => [_createVNode(_component_a_textarea, {
                    value: $setup.DMConfig.Model.fBeforeTipTpl,
                    "onUpdate:value": _cache[2] || (_cache[2] = $event => $setup.DMConfig.Model.fBeforeTipTpl = $event),
                    "allow-clear": ""
                  }, null, 8, ["value"])]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "label-col"])])]),
      _: 1
    }, 8, ["spinning"])]),
    _: 1
  }, 8, ["visible", "confirmLoading", "title", "width", "wrap-class-name", "onOk"]);
}